import React, { FC, useContext } from 'react';
import { css } from '@emotion/core';

import { colors } from '@/styles';
import { Theme, ThemeContext } from '@/controllers/theme-controller';

const headerStyles = css`
  min-height: 20px;
`;

const commonStyles = css`
  overflow: hidden;
  background-color: ${colors.skeleton()};

  display: inherit;
  color: inherit;
  min-height: 20px;
  position: relative;
  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`;

const shimmerStyles = css`
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    animation: shimmer 2s infinite;
    content: '';
  }
`;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const shimmerDarkStyles = css`
  &::after {
    background-image: linear-gradient(
      90deg,
      rgba(22, 26, 29, 0) 0,
      rgba(22, 26, 29, 0.2) 40%,
      rgba(22, 26, 29, 0.4) 80%,
      rgba(22, 26, 29, 0)
    );
  }
`;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const shimmerLightStyles = css`
  &::after {
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.4) 60%,
      rgba(255, 255, 255, 0)
    );
  }
`;

const copyStyles = css`
  min-height: 11px;
`;

const blockStyles = css`
  height: 40px;
`;

const compactStyles = css`
  min-height: 16px;
`;

type IProps = {
  width?: number;
  isCompact?: boolean;
};

export const SkeletonBlock: FC<IProps> = ({ width }) => {
  const [theme] = useContext(ThemeContext);
  const isDarkTheme: boolean = theme === Theme.Dark;

  return (
    <span css={[commonStyles, blockStyles, isDarkTheme ? '' : shimmerStyles]} style={{ width }} />
  );
};

export const SkeletonHeader: FC<IProps> = ({ width, isCompact }) => {
  const [theme] = useContext(ThemeContext);
  const isDarkTheme: boolean = theme === Theme.Dark;

  return (
    <span
      css={[
        commonStyles,
        headerStyles,
        isCompact ? compactStyles : '',
        shimmerStyles,
        isDarkTheme ? shimmerDarkStyles : shimmerLightStyles,
      ]}
      style={{ width }}
    />
  );
};

export const SkeletonCopy: FC<IProps> = ({ width }) => {
  const [theme] = useContext(ThemeContext);
  const isDarkTheme: boolean = theme === Theme.Dark;

  return (
    <span css={[commonStyles, copyStyles, isDarkTheme ? '' : shimmerStyles]} style={{ width }} />
  );
};
